/**
 * Quick Variant Selector with Icons
 * Handles variant selection and cart button display
 */

class QuickVariantSelector {
  constructor(element) {
    this.element = element;
    this.productId = element.dataset.productId;
    this.variantButtons = element.querySelectorAll('.variant-icon-btn');
    this.cartWrapper = element.querySelector('.quick-add-cart-wrapper');
    this.variantInput = element.querySelector('.variant-id-input');
    this.cartButton = element.querySelector('.quick-add-cart-btn');

    this.init();
  }

  init() {
    this.attachEventListeners();

    // Show cart button immediately if first variant is selected
    const firstActive = this.element.querySelector('.variant-icon-btn.active');
    if (firstActive) {
      this.showCartButton();
    }
  }

  attachEventListeners() {
    this.variantButtons.forEach(button => {
      button.addEventListener('click', (e) => this.handleVariantClick(e));
    });
  }

  handleVariantClick(event) {
    const button = event.currentTarget;
    const variantId = button.dataset.variantId;
    const isAvailable = button.dataset.available === 'true';

    // Don't allow selection of unavailable variants
    if (!isAvailable) {
      return;
    }

    // Update active state
    this.variantButtons.forEach(btn => btn.classList.remove('active'));
    button.classList.add('active');

    // Update hidden input
    if (this.variantInput) {
      this.variantInput.value = variantId;
    }

    // Update cart button state
    if (this.cartButton) {
      this.cartButton.disabled = !isAvailable;
    }

    // Show cart button
    this.showCartButton();
  }

  showCartButton() {
    if (this.cartWrapper) {
      this.cartWrapper.style.display = 'block';
    }
  }
}

// Initialize all quick variant selectors
function initQuickVariantSelectors() {
  const selectors = document.querySelectorAll('.quick-variant-selector');
  selectors.forEach(selector => {
    new QuickVariantSelector(selector);
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQuickVariantSelectors);
} else {
  initQuickVariantSelectors();
}

// Re-initialize when new products are loaded (for AJAX/infinite scroll)
document.addEventListener('product:loaded', initQuickVariantSelectors);
